import { render, staticRenderFns } from "./EnterChatDialog.vue?vue&type=template&id=2abbb702&"
import script from "./EnterChatDialog.vue?vue&type=script&lang=js&"
export * from "./EnterChatDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports